import { createSlice } from "@reduxjs/toolkit";

const dataGridSlice = createSlice({
    name: 'dataGridSlice',
    initialState: {
        size: 'compact',
        rows1Data: [],
        rows2Data: [],
    },
    reducers: {
        updateGridSize: (state, action) => { state.size = action.payload },
        updateRow1Data: (state, action) => { state.rows1Data = action.payload },
        updateRow2Data: (state, action) => { state.rows2Data = action.payload },
    }
})

export const {
    updateGridSize,
    updateRow1Data,
    updateRow2Data
} = dataGridSlice.actions;

export const dataGridReducer = dataGridSlice.reducer
